import { logger } from "@otto-ec/global-resources/debug";
import { onReady } from "@otto-ec/global-resources/dom";

const log = logger("oc.performance.init");

const marks = [
  "otto-components-init",
  "otto-components-init-start",
  "otto-components-init-end",
] as const;

const elements = new Set<HTMLElement>();
const state = [false, false] as [documentReady: boolean, initComplete: boolean];

try {
  window.performance.mark(marks[1]);
  log.info("%s marked with %s", marks[1], performance.now());
  /*                                                                   */
} catch (e) {}

onReady.sub(() => {
  /*                                   */
  state[0] = true;
});

/**
 *
 *
 */
export const registerElementInit = (el: HTMLElement): void => {
  /*                                               */
  if (state[0] || state[1]) return;
  elements.add(el);
};

/**
 *
 *
 */
export const completeElementInit = (el: HTMLElement, p = window.performance): void => {
  elements.delete(el);

  /*                                              */
  /*                                  */
  if (!state[1] && elements.size < 1) {
    p.mark(marks[2]);
    log.debug("%s marked with %s", marks[2], p.now());
  }

  /*                              */
  /*                                                         */
  if (state[1] || !state[0] || elements.size > 0) return;

  /*                                   */
  try {
    state[1] = true;
    const measure = p.measure(...marks);
    log.info("%s completed with: %sms", marks[0], measure.duration, { measure });
    /*                                          */
    /*                                        */
    /*                                       */
  } catch (e) {
    log.warn("Failed to mark oc init", e);
  }
};
